module.exports = __webpack_public_path__ + "static/media/DSC_0376.73a6f1b6.jpg";